import Icon from "@/components/common/icon";

export default function Wp() {
  return (
    <a
      href="https://wa.me/+79811779326"
      target="_blank"
      rel="noreferrer"
      id="wpLink"
    >
      <Icon id="wp" size={50} />
    </a>
  );
}
